export default __webpack_public_path__ + "static/media/microbiologis.12634584.png";